module.exports = __webpack_public_path__ + "static/map-ad0774af2abfbf2ffc2bcfeda5202865.png";